export default __webpack_public_path__ + "static/media/empty.f877e0bd.svg";